import services from 'api/services';
import { logError } from 'util/errors';

import { SET_UNSUBSCRIBE_REQUEST, SET_UNSUBSCRIBE_SUCCESS, SET_UNSUBSCRIBE_FAILURE } from './constants';

const { AccountService } = services;

export const unsubscribeUser = (accountId) => async (dispatch) => {
  try {
    dispatch({ type: SET_UNSUBSCRIBE_REQUEST });
    const response = await AccountService.unsubscribeUser(accountId);
    dispatch({ type: SET_UNSUBSCRIBE_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: SET_UNSUBSCRIBE_FAILURE, error: ex.message });
  }
};
